import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import SnackBar from '../General/SnackBar';
import { useEffect } from 'react';
import { GetCspForFos } from 'API/fos_ist/api';
import BackdropLoader from '../General/Loader';
import { Box, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { formatDate } from 'utils/DateFormater';
import { IoClose } from 'react-icons/io5';
import TablePagination from '@mui/material/TablePagination';

export default function MappedUserDialog(props) {


  const [Data, setData] = useState(null)
  const [IsLoading, setIsLoading] = useState(false);
  const [Alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'success'
  })

  const handleAlertOpen = (message, severity) => {
    setAlert({
      open: true,
      message: message,
      severity: severity
    });
  }

  const handleAlertClose = () => {
    setAlert({
      open: false,
      message: '',
      severity: 'success'
    });
  }

  useEffect(() => {

    if (props.open && props.fos) {
      GetCspForFos(1,props.fos, setIsLoading, setData, handleAlertOpen);
    }

  }, [props.open])


  const handleChangePage = (event, newPage) => {
          GetCspForFos(newPage+1,props.fos, setIsLoading, setData, handleAlertOpen);
  }

  console.log("Data", Data);


  return (
    <React.Fragment>

      <BackdropLoader open={IsLoading} />

      <SnackBar open={Alert.open} type={Alert.severity} message={Alert.message} handleClose={handleAlertClose} />

      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"

        sx={{
          '& .MuiDialog-paper': {
            height: '80vh',
            overflowY: 'auto',
          },
        }}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h5" sx={{ fontWeight: 700, color: "#592375" }}>Mapped CSP</Typography>
        </DialogTitle>
        <Box sx={{ position: 'absolute', top: 0, right: 0, padding: 2, fontSize: "22px", cursor: 'pointer' }} onClick={props.handleClose}>
          <IoClose />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>CSP Name</TableCell>
                    <TableCell align="left">CSP Code</TableCell>
                    <TableCell align="left">Mobile</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Date of Mapping</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Data && Data.data && Array.isArray(Data.data) && Data.data.map((row) => (
                    <TableRow
                      key={row._id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.agent_name ? row.agent_name : "-"}
                      </TableCell>
                      <TableCell align="left">{row.agent_code ? row.agent_code : "-"}</TableCell>
                      <TableCell align="left">{row.mobile ? row.mobile : "-"}</TableCell>
                      <TableCell align="left">{row.email ? row.email : "-"}</TableCell>
                      <TableCell align="left">{row.mapping_date ? formatDate(row.mapping_date) : "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>


              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={Data?.total || 0}
              page={(Data?.page || 1) - 1}
              onPageChange={handleChangePage}
              rowsPerPage={10}
              rowsPerPageOptions={[10]}
            />

          </DialogContentText>
        </DialogContent>

      </Dialog>
    </React.Fragment>
  );
}
